import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "@store/store-helper";
import { UiState } from "@store/ui/ui-slice";

/**
 * Returns the format that the data is displayed
 */
export const dataViewModeSelector: (state: RootState) => UiState["dataViewMode"] =
  createSelector(
    (state: RootState) => state,
    (state: RootState) => {
      return state.ui.dataViewMode;
    }
  );

/**
 * Returns the sidebar property
 */
export const sidebarSelector: (state: RootState) => UiState["sidebar"] =
  createSelector(
    (state: RootState) => state,
    (state: RootState) => {
      return state.ui.sidebar;
    }
  );

/**
 * Returns the search property
 */
export const searchSelector: (state: RootState) => UiState["search"] =
  createSelector(
    (state: RootState) => state.ui,
    (uiState) => {
      return uiState.search;
    }
  );

/**
 * Returns the numUnreadMsg property
 */
export const numUnreadMsgSelector: (state: RootState) => UiState["numUnreadMsg"] =
  createSelector(
    (state: RootState) => state,
    (state: RootState) => {
      return state.ui.numUnreadMsg;
    }
  );

/**
 * Returns the UI state related to the Data Management editor.
 */
export const dataManagementUISelector: (state: RootState) => UiState["dataManagement"] =
  createSelector(
    (state: RootState) => state,
    (state: RootState) => {
      return state.ui.dataManagement;
    }
);
